exports.default = {
  // 侧边栏导航
  'general': '通用',
  'domains': '域名',
  
  // 通用设置面板
  'current_version': '当前版本：{version}',
  'open_website': '打开网站',
  'publish_and_access': '发布与访问',
  'domain': '域名',
  'custom_domain': '自定义域名',
  'your_website_not_online': '您的网站尚未正式上线，仅通过预览链接供您访问。',
  'status': '状态',
  'online': '已上线',
  'publishing': '上线中',
  'not_published': '未发布',
  'publish': '发布',
  'unpublish': '取消发布',
  
  // 域名设置面板
  'copy': '复制',
  'not_generated_link': '尚未生成链接',
  'custom_domain_with_icon': '自定义域名',
  'keep_subscription_valid': '为确保您的自定义域名保持可访问状态，请保持订阅有效。一旦订阅过期，该域名可能无法再访问网站。',
  'connect_existing_domain': '连接现有域名',
  'if_you_have_existing_domain': '如果您已有域名，可以在此连接',
  'connect_domain': '连接域名',
  'loading': '加载中...',
  'no_more': '没有更多了',
  
  // 域名状态 - 已验证
  'connected': '已连接',
  'disconnect': '断开连接',
  
  // 域名状态 - 已失效/已过期
  'invalid': '已失效',
  'expired': '已过期',
  'reconnect': '重新连接',
  'reconfigure': '重新配置',
  
  // 域名状态 - 待验证
  'pending_verification': '待验证',
  'please_complete_configuration': '请完成配置。剩余时间：',
  'time_remaining': '剩余时间：{time}',
  'check_again': '再次检查',
  'use_a_record': '使用 A 记录配置',
  'use_cname_record': '使用 CNAME 配置',
  'record_type': '记录类型',
  'record_name': '记录名称',
  'value': '值',
  'empty_or_at': '空 或',
  'no_corresponding_records': '暂无对应类型的记录信息',
  'configuration': '配置',
  'unknown': '未知',
  
  // DNS 配置说明
  'how_to_configure': '如何配置',
  'use_a_record_to_point': '使用 "{name}" 将您的域名指向以下 IP 地址：{ip_address}',
  'use_cname_to_apply_to_root_domain': '使用 "{name}" 将 CNAME 应用到您的根域名  (例如:example.com)',
  'dns_propagation_notice': '注意：添加 DNS 记录后，变更可能需要一些时间才能完全传播到整个互联网。',
  
  // 连接域名弹窗
  'connect_domain_dialog_title': '连接域名',
  'external_domain': '外部域名',
  'if_you_have_domain_from_other_platform': '如果您已经在其他平台拥有一个域名，可以在此连接。',
  'please_enter_domain': '请输入域名',
  'bind_both_domain_and_www': '同时设置 {domain} 和 www.{domain}',
  'recommended': '推荐',
  'cancel': '取消',
  'confirm_connect': '确认连接',
  
  // 域名冲突提示弹窗
  'domain_bind_notice': '域名绑定提示',
  'following_domains_used_by_your_other_projects': '以下域名已被您的其他项目使用：',
  'you_can_rebind_to_current_project': '您可以将其换绑到当前项目',
  'rebind_now': '继续换绑',
  'following_domains_bound_by_other_users': '以下域名已被其他用户绑定，无法操作：',
  'already_occupied': '已被占用',
  'close': '关闭',
  
  // 消息提示
  'copied_to_clipboard': '已复制到剪贴板',
  'website_published_successfully': '网站已成功发布上线',
  'unpublished': '已取消发布',
  'network_or_server_error': '网络或服务器异常，绑定失败',
  'reconnect_request_failed': '重新连接请求失败',
  'bind_success': '绑定成功',
  'domain_already_bound_by_other_user': '域名 {domain} 已被其他用户绑定',
  'partial_bind_success': '部分域名绑定成功：{domains}',
  'bind_failed': '绑定失败',
  'rebind_success': '域名 {domain} 换绑成功',
  'rebind_request_error': '换绑请求异常',
  'disconnected': '已断开 {domain} 的连接',
  'disconnect_failed': '断开连接失败',
  'dns_verification_passed': '域名 {domain} DNS 验证通过',
  'dns_verification_failed': 'DNS 验证未通过，请检查配置是否正确',
  'check_dns_failed': '检查 DNS 失败',
  'invalid_domain_format': '请输入正确的域名格式',
  
  // WebPreviewPanel 新增
  'settings': '设置',
  'public_url': '公共 URL',
  'link_not_generated': '尚未生成链接',
  'add_custom_domain': '自定义域名',
  'unknown_version': '未知版本',
  'version_prefix': 'V{version}'
}
